var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.07,
    height: 148.29,
    viewBox: "0 0 114.07 148.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#53a1fe;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cms-icon-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.41 148.29 11.41 136.88 22.81 136.88 22.81 148.29 17.11 142.58 11.41 148.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.07,22.82v91.25a22.81,22.81,0,0,1-22.82,22.81H11.41A11.4,11.4,0,0,1,0,125.47V11.41A11.41,11.41,0,0,1,11.41,0H91.25a22.81,22.81,0,0,1,22.82,22.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.81,84.65A4.79,4.79,0,0,1,83,91.54L81.2,93.3l-1.57,1.56a4.79,4.79,0,0,1-6.58.16,23.26,23.26,0,0,0-6.26-4.21A2,2,0,0,1,65.68,89V83.89a1.52,1.52,0,0,0-1.13-1.48,30.83,30.83,0,0,0-15,0,1.51,1.51,0,0,0-1.12,1.48V89a2,2,0,0,1-1.12,1.78A23.41,23.41,0,0,0,41,95a4.79,4.79,0,0,1-6.58-.16L32.88,93.3l-1.76-1.76a4.79,4.79,0,0,1,.14-6.89,37.62,37.62,0,0,1,51.55,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.78,
    y: 40.09,
    width: 28.52,
    height: 28.52,
    rx: 14.26,
    transform: "translate(111.38 -2.69) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.9e272af5f64af6e764b764e194eabb1c.svg";
export { ForwardRef as ReactComponent };